import React, { useEffect, useRef } from 'react';

import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import HighchartsExporting from 'highcharts/modules/exporting';

export interface ChartOptions extends Highcharts.Options {}

interface IPriceChart {
    options: ChartOptions;
    navStart?: number;
    navEnd?: number;
    timezoneOffset?: any;
    allowChartUpdate?: boolean;
}

const PriceChart = (props: IPriceChart) => {
    if (typeof Highcharts === 'object') {
        HighchartsExporting(Highcharts);
    }

    const { options, navStart, navEnd, allowChartUpdate } = props;
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);

    useEffect(() => {
        chartComponentRef?.current?.chart?.series[0]?.xAxis.setExtremes(navStart, navEnd);
    }, [navStart]);

    return (
        <HighchartsReact
            allowChartUpdate={allowChartUpdate ?? true}
            highcharts={Highcharts}
            options={options}
            constructorType={'stockChart'}
            ref={chartComponentRef}
        />
    );
};

export { PriceChart };
